export const TicketTagIds = Object.freeze({
    MP_Lead: 102,
    MP_Registrierung: 101,
    MP_Anlagenverwaltung: 96,
    MP_Anlage_hinzufügen: 99,
    MP_Anmeldung: 97, 
    MP_Abmeldung: 98,
    MP_Gebäude_hinzufügen: 100,
    Verwaltungswechsel: 95,
    MP: 27,
    MP_Monatsrechnung: 117,
    MP_Feedback: 125,
    Aufgabe: 44,
    Frage: 119,
    TZB: 113,
})